import { useMutation } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';
import { extractErrorMessage } from '../extractErrorMessage';


const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};
export function useLinkCorporateAccount() {
  return useMutation({
    mutationFn: async ({ company_name, company_policy_no, company_id, staff_id }) => {
      const data = {
        company_name,
        company_policy_no,
        staff_id,
      };

      if (company_id) {
        data.company_id = company_id;
      }

      try {
        // Make the request to link the corporate account
        const result = await serverRequest(
          'POST',
          'link/corporate-account',
          data
        );
        
        // If the result is not successful, throw an error
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to link account');
        }
        
        return result;
      } catch (error) {
        // Extract the error message
        const errorMessage = extractErrorMessage(error, 'Failed to link account');
        
        // Use notifyOnce to ensure the error is only shown once
        notifyOnce("error", errorMessage, "Error");
        
        // Throw the error to ensure React Query handles the mutation failure properly
        throw new Error(errorMessage);
      }
    },
  });
}
